import React, { useEffect, useRef, useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import "./selectMenu.scss";
import selectIcon from "./selectmenuIcon";
import Tooltip from "@mui/material/Tooltip";

export default function SelectMenu({
  listData,
  onchangehandler,
  name,
  value,
  placeholder,
  disabled,
  isError = false,
  errorMsg = "Selection is required for this field",
  isKeyValue = true,
  isId = false,
  disabledDefault,
  isgroupplaceholder,
  customClass = false,
  clearIcon = false,
}) {
  const textRef = useRef(null);

  const handleClear = (event) => {
    event.stopPropagation(); // Prevents menu from opening when clicking clear button
    onchangehandler({ target: { name, value: "" } });
  };
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    if (textRef?.current) {
      setShowTooltip(
        textRef?.current?.scrollWidth > textRef?.current?.clientWidth
      );
    }
  }, [value, listData]);

  return (
    <div className="overideSelectMenu">
      <Select
        IconComponent={selectIcon}
        className="selectBox"
        size="small"
        labelId="demo-simple-select-label"
        value={value === null ? "" : value}
        name={name}
        displayEmpty
        disabled={disabled}
        id="demo-simple-select"
        onChange={(e) => onchangehandler(e)}
        renderValue={
          value !== null && value !== "" && value !== "null"
            ? (selected) => {
                const selectedText =
                  listData?.find(
                    (data) =>
                      (isKeyValue ? data.key : data.articleCatSubcatId) ===
                      selected
                  )?.value || placeholder;

                return (
                  <Tooltip
                    title={showTooltip ? selectedText : ""}
                    disableHoverListener={!showTooltip}
                    arrow
                  >
                    <div className="selectedValue" ref={textRef}>
                      {selectedText}
                    </div>
                  </Tooltip>
                );
              }
            : () => <div className="placeholder">Please Select</div>
        }
      >
        {disabledDefault ||
          (isgroupplaceholder && (
            <MenuItem disabled={disabledDefault} value="0">
              <em>{placeholder}</em>
            </MenuItem>
          ))}

        {listData &&
          listData?.map((data) => (
            <MenuItem
              key={isKeyValue ? data.key : data.articleCatSubcatId}
              value={isKeyValue ? data.key : data.articleCatSubcatId}
              className={
                customClass
                  ? `${customClass} selectutilityitems`
                  : "selectutilityitems"
              }
            >
              {isKeyValue
                ? isId
                  ? `${data.value} (${data.key})`
                  : data.value
                : data.title}
            </MenuItem>
          ))}
      </Select>
      {clearIcon && (
        <IconButton size="small" className="clearButton" onClick={handleClear}>
          <ClearIcon fontSize="small" />
        </IconButton>
      )}

      {(value?.length === 0 || !value) && isError && (
        <FormHelperText className="errorText">{errorMsg}</FormHelperText>
      )}
    </div>
  );
}
